import { CreateExamSurveyUserAnswerInput } from 'generated/graphql'
import { ExamSurveyFormFields } from '../../schema/examSurveySchema'

const parseSubmitExamSurvey = (data: ExamSurveyFormFields) => {
  const inputQuestions: CreateExamSurveyUserAnswerInput[] = []

  Object.values(data.inputQuestions).map((inputQuestion) => {
    Object.values(inputQuestion).map(
      (answerInput: CreateExamSurveyUserAnswerInput) => {
        inputQuestions.push({
          ...answerInput,
          numericAnswer: Number(answerInput.numericAnswer),
        })
      },
    )
  })

  const parseData = [
    ...Object.values(data.choiceOneQuestions),
    ...inputQuestions,
  ]

  return parseData
}

export default parseSubmitExamSurvey
